export function resolveTemplateSenderName(activeStaff, activeDoctor, user) {
  for (const candidate of [
    activeStaff?.name,
    activeDoctor?.full_name,
    user?.full_name,
    user?.email,
    "Practitioner",
  ]) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  return "Practitioner";
}

function resolveConversationActorLabel(
  message,
  { aiLabel = "AI assistant", defaultHumanLabel = "Team member", displayName },
) {
  if (message.role === "user") {
    return displayName;
  }
  if (message.role === "assistant") {
    return aiLabel;
  }
  return message.sender_name?.trim() || defaultHumanLabel;
}

export function buildConversationMeta(message, date, options) {
  const actorLabel = resolveConversationActorLabel(message, options);
  if (message.role === "human" && message.is_template) {
    return `${actorLabel} | Template | ${date}`;
  }
  return `${actorLabel} | ${date}`;
}

export function buildReplyPreviewLabel(message, options) {
  const actorLabel = resolveConversationActorLabel(message, options);
  if (message.role === "human" && message.is_template) {
    return `${actorLabel} | Template`;
  }
  return actorLabel;
}
